import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import { styles } from "./style";
import moment from "moment";

const subColumns = [
  { key: "event", label: "Event", style: styles.colEvent },
  { key: "time", label: "Time", style: styles.colTime },
  { key: "lat", label: "Lat", style: styles.colLat },
  { key: "lng", label: "Lng", style: styles.colLng },
  { key: "accuracy", label: "Accuracy", style: styles.colAccuracy },
  { key: "distance", label: "Distance", style: styles.colDistance },
  { key: "address", label: "Address", style: styles.colAddress },
  { key: "device", label: "Device", style: styles.colDevice },
  { key: "locSrc", label: "Loc Source", style: styles.colLocSrc },
  { key: "ip", label: "IP", style: styles.colIp },
];

const headerFields = [
  { key: "staffName", label: "Staff" },
  { key: "date", label: "Date" },
  { key: "facility", label: "Facility" },
  { key: "type", label: "Type" },
  { key: "clientName", label: "Client" },
  { key: "service", label: "Service" },
  { key: "evvEnforced", label: "EVV" },
  { key: "status", label: "Status" },
];

const SubTableHeader = () => (
  <View style={styles.subTableHeaderRow}>
    {subColumns.map((col) => (
      <View key={col.key} style={col.style}>
        <Text style={styles.subTableHeaderCell}>{col.label}</Text>
      </View>
    ))}
  </View>
);

const SubTableRow = ({ row, alt }) => (
  <View style={alt ? styles.subTableRowAlt : styles.subTableRow}>
    {subColumns.map((col) => (
      <View key={col.key} style={col.style}>
        <Text style={styles.subTableCell}>{row[col.key] ?? ""}</Text>
      </View>
    ))}
  </View>
);

const RecordCard = ({ record, index }) => {
  const clockInRow = {
    event: "Clock-In",
    time: record.clockInTime,
    lat: record.clockInLat,
    lng: record.clockInLng,
    accuracy: record.clockInAccuracy,
    distance: record.clockInDistance,
    address: record.clockInAddress,
    device: record.clockInDeviceType,
    locSrc: record.clockInLocationSource,
    ip: record.clockInIp,
  };
  const clockOutRow = {
    event: "Clock-Out",
    time: record.clockOutTime,
    lat: record.clockOutLat,
    lng: record.clockOutLng,
    accuracy: record.clockOutAccuracy,
    distance: record.clockOutDistance,
    address: record.clockOutAddress,
    device: record.clockOutDeviceType,
    locSrc: record.clockOutLocationSource,
    ip: record.clockOutIp,
  };

  return (
    <View style={styles.recordCard} wrap={false}>
      <View style={styles.cardHeader}>
        {headerFields.map((f) => (
          <View key={f.key} style={styles.cardHeaderItem}>
            <Text style={styles.cardLabel}>{f.label}:</Text>
            <Text style={styles.cardValue}>{record[f.key] ?? ""}</Text>
          </View>
        ))}
      </View>
      <SubTableHeader />
      <SubTableRow row={clockInRow} alt={false} />
      <SubTableRow row={clockOutRow} alt={true} />
      {record.serviceAddress ? (
        <View style={styles.cardFooter}>
          <Text style={styles.cardFooterLabel}>Service Address:</Text>
          <Text style={styles.cardFooterValue}>{record.serviceAddress}</Text>
        </View>
      ) : null}
    </View>
  );
};

export const EvvRecordsPdf = ({ data, dateRange, facilityName }) => {
  const startStr = dateRange?.start
    ? moment(dateRange.start).format("MM/DD/YYYY")
    : "All";
  const endStr = dateRange?.end
    ? moment(dateRange.end).format("MM/DD/YYYY")
    : "All";

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.header}>
          <Image
            src="/assets/images/logo2.png"
            style={styles.logo}
            alt="logo"
          />
          <Text style={styles.reportTitle}>EVV Records Report</Text>
          {facilityName && (
            <Text style={styles.facilityName}>{facilityName}</Text>
          )}
          <Text style={styles.reportPeriod}>
            {startStr} - {endStr}
          </Text>
          <Text style={styles.entryCount}>{data.length} record(s)</Text>
        </View>

        {data.map((record, i) => (
          <RecordCard key={i} record={record} index={i} />
        ))}

        <View style={styles.footer} fixed>
          <Text>{facilityName ? `${facilityName} EVV Records` : "Ogiso EVV Records"}</Text>
          <Text
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  );
};
